class MiniCart extends HTMLElement {
  constructor() {
    super();

    this.onCartUpdated = this.onCartUpdated.bind(this);

    this.addEventListener('click', (event) => {
      const upsellButton = event.target.closest('.add-upsell--button');
      if (!upsellButton) return;

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', Number(upsellButton.dataset.upsellVariantId));
      formData.append('quantity', 1);

      config.body = formData;

      const sections = this.getSectionsToRender()
        .map((section) => section.section)
        .join(',');

      return fetch(
        `${window.routes.cart_add_url}.js?sections=${sections}`,
        config
      )
        .then((response) => {
          if (!response.ok) throw new Error('Cart add error');
          return response.json(); 
        })
        .then((parsedState) => {
          this.renderContents(parsedState);
        })
        .catch((error) => {
          console.error(error);
        });
    });

    window.addEventListener('cart:updated', this.onCartUpdated);

  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  onCartUpdated(event) {
    const state = event?.detail?.cart;
    if (!state) return;

    let parsed;
    try {
      parsed = JSON.parse(state);
    } catch (e) {
      console.error('Cart parse error', e);
      return;
    }

    const miniCartHtml = parsed?.sections?.['mini-cart'];
    if (!miniCartHtml) return;

    this.validateFreeFromCartDoc(miniCartHtml);
  }

  validateFreeFromCartDoc(data) {
    let cartData = new DOMParser().parseFromString(data, 'text/html');
    const script = cartData.querySelector('.cart-custom-data');

    if (!script) return;

    const giftData = JSON.parse(script.textContent || '{}');
    const rules = giftData.cart_products || [];

    // console.log(rules)
    const nonGiftElements = Array.from(cartData.querySelectorAll('[data-cart-item-id]:not(.gift--item)')).map(el => el.getAttribute('data-cart-item-id')) || [];

    const cartGiftElements = Array.from(cartData.querySelectorAll('[data-cart-item-id].gift--item'))
        .map(el => el.getAttribute('data-cart-item-id'));

    // console.log(nonGiftElements, "!!!!!!!")
    // console.log(cartGiftElements, "???????")
    const updates = {}


    if(cartGiftElements.length === 0) return;

    cartGiftElements.forEach(el => {
        if(rules.length === 0) {
            updates[el] = 0;
            return;
        }
        rules.forEach((rule) => {

            if(rule.gifts?.includes(Number(el)) && !nonGiftElements.includes(rule.main_product) || nonGiftElements.length === 0) {
                updates[el] = 0;
            }
            // console.log(!nonGiftElements.includes(rule.main_product))
            // console.log(rule.gifts?.includes(Number(el)))
        })
    });

    if (Object.keys(updates).length > 0) {
         const sections = this.getSectionsToRender()
           .map((section) => section.section)
           .join(',');

         fetch(`/cart/update.js?sections=${sections}`, {
             method: 'POST',
             headers: {
                 'Content-Type': 'application/json',
                 'Accept': 'application/json'
             },
             body: JSON.stringify({updates})
         })
         .then((response) => {
           if (!response.ok) throw new Error('Cart update error');
           return response.json();
         })
         .then((parsedState) => {
           this.renderContents(parsedState);
         })
         .catch((error) => {
           console.error(error);
         });
    }
  }
}

customElements.define('mini-cart', MiniCart);
